import React from "react";

import "../styles/Warning.css";

function Warning() {
  return (
    <div className="Warning">
      <h2> No location found </h2>
      <p> Try again</p>
    </div>
  );
}

export default Warning;
